import {
  initialize,
  saveTokenAuthUser,
  saveTokenSmiles,
  removeTokenAuthUser,
  removeTokenSmiles,
  getMemberNumberByAuthUser,
  getUrlAndHeaderByType,
  axiosInstance,
} from './ConfigHelper';
import { API } from './api';
export { default as BugsnagConfig } from './bugsnag';
export { configureMock, cleanMocks } from './mock_api';
export { EventsLogger } from './events';
export { Logger } from './logger';

export default {
  initialize,
  saveTokenAuthUser,
  saveTokenSmiles,
  removeTokenAuthUser,
  removeTokenSmiles,
  getMemberNumberByAuthUser,
  API,
  getUrlAndHeaderByType,
  axiosInstance,
};
